const defaultState = {
	plants: [],
	shopCds: [],
	stnCds: [],
	lines: [],
	hids: [],
	cids: [],

	searchParams: {
		plantCd: null,
		shopCd: 'ALL',
		stnCd: 'ALL',
		hid: 'ALL'
	},

	flags: [],

	stations: {
		currentPage: 1,
		pageUnit: null,
		totalSize: 0,
		data: []
	},

	popupParams: {
		type: '',
		show: false,
		selectedRow: {}
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
